import { useLingui } from '@lingui/react/macro';

import { toaster } from '#features/ui/components/Toaster';
import { openNotificationSettings } from '../utils/deviceSettings';

/** A failed native transition must leave a visible way to recover manually. */
export const useOpenNotificationSettings = () => {
  const { t } = useLingui();

  return async () => {
    if (await openNotificationSettings()) {
      return;
    }
    toaster.create({
      type: 'error',
      title: t`Something went wrong`,
      description: t`Allow notifications in the system settings for Teamplay, then come back to this screen.`,
    });
  };
};
